import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";

import { base_url } from "../../context/Authcontext";
import { useNavigate } from "react-router-dom";


const SpribeHome = () => {
  const [isSidebar, setSidebar] = useState(false);
  const navigate= useNavigate();


  const spribe_games=[
    {
      src: "https://bindaaswin.com/jdb_images/22001_200x200_en.png",
      name: "Aviator",
      GAMEID:
        "a04d1f3eb8ccec8a4823bdf18e3f0e84",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22002_200x200_en.png",
      name: "Dice",
      GAMEID:
        "8a87aae7a3624d284306e9c6fe1b3e9c",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22003_200x200_en.png",
      name: "Goal",
      GAMEID:
        "c68a515f0b3b10eec96cf6d33299f4e2",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22004_200x200_en.png",
      name: "Plinko",
      GAMEID:
        "6ab7a4fe5161936012d6b06143918223",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22005_200x200_en.png",
      name: "Mines",
      GAMEID:
        "5c4a12fb0a9b296d9b0d5f9e1cd41d65",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22006_200x200_en.png",
      name: "Hilo",
      GAMEID:
        "a669c993b0e1f1b7da100fcf95516bdf",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22007_200x200_en.png",
      name: "Keno",
      GAMEID:
        "c311eb4bbba03b105d150504931f2479",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22008_200x200_en.png",
      name: "Mr Roulette",
      GAMEID:
        "9dc7ac6155c5a19c1cc204853e426367",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22009_200x200_en.png",
      name: "Hotline",
      GAMEID:
        "b31720b3cd65d917a1a96ef61a72b672",
      provider: "jdb",
    },
  ]

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    
  },[]);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

               
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Hot Games</span>{" "}
                    {/* <span className="all">See All</span> */}
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={spribe_games} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default SpribeHome;
